import React, { Fragment } from "react";
import G03Sliders from "../../guestappcomponents/G03Sliders/G03Sliders";
import G04Highlights from "../../guestappcomponents/G04Highlights/G04Highlights";
import G05HowItWorks from "../../guestappcomponents/G05HowItWorks/G05HowItWorks";
import G06InsideTheAcademy from "../../guestappcomponents/G06InsideTheAcademy/G06InsideTheAcademy";
import G07Courses from "../../guestappcomponents/G07Courses/G07Courses";
import G08Testimonial from "../../guestappcomponents/G08Testimonial/G08Testimonial";
import G09ConversionCTA from "../../guestappcomponents/G09ConversionCTA/G09ConversionCTA";
import TestHighlights from "../../guestappcomponents/TestHighlights/TestHighlights";

const P01HomePage = () => {
  return (
    <Fragment>
      <G03Sliders options={{ slider_version: "version_1" }} />
      <main>
        {/*      <G04Highlights /> */}
        <TestHighlights />
        <G05HowItWorks />
        <G06InsideTheAcademy />
        <G07Courses />
        <G08Testimonial />
        <G09ConversionCTA />
      </main>
    </Fragment>
  );
};

export default P01HomePage;
